import { normalize, schema } from 'normalizr'
import {
  createReducer,
  createRequestReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { combineReducers } from 'redux'

const normalizeSlides = data => {
  const slide = new schema.Entity('slides')
  return normalize(data, [slide])
}

const updateSlide = (state, { response, params }) =>
  params.immediateUpdate
    ? state
    : {
        ...state,
        entities: {
          slides: {
            ...state.entities.slides,
            [response.data.slide.id]: response.data.slide
          }
        }
      }

const PresentationReducer = combineReducers({
  fetching: createRequestReducer('PRESENTATION:FETCH'),
  createSlideRequest: createRequestReducer('PRESENTATION:CREATE_SLIDE'),
  updateSlideRequests: createMappedRequestReducer('PRESENTATION:UPDATE_SLIDE'),
  deleteSlideRequests: createMappedRequestReducer('PRESENTATION:DELETE_SLIDE'),
  updatePropertiesRequest: createRequestReducer(
    'PRESENTATION:UPDATE_PROPERTIES'
  ),
  duplicateSlideRequest: createRequestReducer('PRESENTATION:DUPLICATE_SLIDE'),
  uploadImageRequests: createMappedRequestReducer(
    'PRESENTATION:UPLOAD_IMAGE_TO_SLIDE'
  ),
  presentation: createReducer(null, {
    'PRESENTATION:FETCH_REQUEST': () => null,
    'PRESENTATION:RESET': () => null,
    'PRESENTATION:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.presentation,
    'PRESENTATION:UPDATE_PROPERTIES_REQUEST_SUCCESS': (
      state,
      { response }
    ) => ({
      ...state,
      ...response.data.presentation
    }),
    'PRESENTATION:UPLOAD_IMAGE_TO_SLIDE_REQUEST_SUCCESS': (
      state,
      { response }
    ) => {
      return response.data.slide.type !== 'Title'
        ? state
        : {
            ...state,
            image: response.data.slide.image
          }
    },
    'PRESENTATION:REMOVE_IMAGE_FROM_SLIDE': (state, { params }) => {
      return !params || params.type !== 'Title'
        ? state
        : {
            ...state,
            image: null
          }
    }
  }),
  slides: createReducer(null, {
    'PRESENTATION:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeSlides(response.data.presentation.slides),
    'PRESENTATION:ADD_ASSET': (state, { slides }) => normalizeSlides(slides),
    'PRESENTATION:CREATE_SLIDE_REQUEST_SUCCESS': (state, { response }) => {
      const slides = {
        ...state.entities.slides,
        [response.data.slide.id]: response.data.slide
      }

      response.data.ordered_slide_ids.forEach(
        (id, index) => (slides[id] = { ...slides[id], order: index })
      )

      return {
        entities: {
          slides
        },
        result: [...state.result, response.data.slide.id]
      }
    },
    'PRESENTATION:UPDATE_SLIDE_DIRECT': (state, { slide }) => ({
      ...state,
      entities: {
        slides: {
          ...state.entities.slides,
          [slide.id]: slide
        }
      }
    }),
    'PRESENTATION:UPDATE_SLIDE_REQUEST_SUCCESS': updateSlide,
    'SUCCESS_CRITERIA_SLIDE:UPDATE_REQUEST_SUCCESS': updateSlide,
    'PRESENTATION:UPLOAD_IMAGE_TO_SLIDE_REQUEST_SUCCESS': (
      state,
      { response }
    ) => ({
      ...state,
      entities: {
        slides: {
          ...state.entities.slides,
          [response.data.slide.id]: response.data.slide
        }
      }
    }),
    'PRESENTATION:DELETE_SLIDE_REQUEST_SUCCESS': (state, { params }) => {
      const slides = { ...state.entities.slides }
      delete slides[params.id]
      return {
        entities: {
          slides
        },
        result: state.result.filter(id => id !== params.id)
      }
    },
    'PRESENTATION:IMMEDIATE_UPDATE': (state, { id, data }) => ({
      ...state,
      backup: {
        ...state.backup,
        [id]: { ...state.entities.slides[id] }
      },
      entities: {
        slides: {
          ...state.entities.slides,
          [id]: {
            ...state.entities.slides[id],
            ...data
          }
        }
      }
    }),
    'PRESENTATION:RESTORE_SLIDE': (state, { id }) => ({
      ...state,
      entities: {
        slides: {
          ...state.entities.slides,
          [id]: { ...state.backup[id] }
        }
      }
    }),
    'PRESENTATION:RESTORE_ALL_SLIDES': state => ({
      ...state,
      entities: {
        slides: {
          ...state.entities.slides,
          ...state.backup
        }
      }
    }),
    'PRESENTATION:REORDER_SLIDES': (state, { slidesOrder }) => {
      const slides = { ...state.entities.slides }
      slidesOrder.forEach(
        (id, index) => (slides[id] = { ...slides[id], order: index })
      )
      return {
        ...state,
        backup: {
          ...state.entities.slides
        },
        entities: {
          slides: slides
        }
      }
    },
    'PRESENTATION:REMOVE_IMAGE_FROM_SLIDE': (state, { id }) => ({
      ...state,
      backup: {
        ...state.entities.slides
      },
      entities: {
        slides: {
          ...state.entities.slides,
          [id]: {
            ...state.entities.slides[id],
            image: null
          }
        }
      }
    }),
    'PRESENTATION:UPDATE_NOTES_REQUEST_SUCCESS': (state, { response }) => ({
      ...state,
      entities: {
        slides: {
          ...state.entities.slides,
          [response.data.slide.id]: {
            ...state.entities.slides[response.data.slide.id],
            public_note: response.data.slide.public_note,
            private_note: response.data.slide.private_note
          }
        }
      }
    }),
    'PRESENTATION:DUPLICATE_SLIDE_REQUEST_SUCCESS': (state, { response }) =>
      normalizeSlides(response.data.presentation.slides)
  })
})

export default PresentationReducer
